import { Typography } from '@euler/app/components/typography';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { LinearGradient } from 'expo-linear-gradient';
import { memo, ReactNode } from 'react';
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';

export const ConstructionJobGradientPanel = memo(
  ({
    title,
    remark,
    style,
    titleStyle,
    headerStyle,
    children,
  }: {
    title: string;
    remark?: ReactNode;
    style?: StyleProp<ViewStyle>;
    titleStyle?: StyleProp<TextStyle>;
    headerStyle?: StyleProp<ViewStyle>;
    children?: ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        css={`
          border-radius: ${rpx(8)}px;
          background-color: #fff;
          overflow: hidden;
        `}
        style={style}
      >
        <LinearGradient
          locations={[0, 1]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          colors={['#2064E7', '#20C3E7']}
          css={`
            height: ${rpx(5)}px;
          `}
        />
        <HStack
          css={`
            margin-bottom: ${rpx(10)}px;
            padding: ${rpx(8)}px ${rpx(15)}px ${rpx(4)}px ${rpx(15)}px;
          `}
          style={headerStyle}
        >
          <Typography.Label
            medium
            size={rpx(18)}
            color="#111"
            style={titleStyle}
          >
            {title}
          </Typography.Label>
          {typeof remark === 'string' ? (
            <Typography.Label light size={rpx(14)} color="#999999">
              {remark}
            </Typography.Label>
          ) : (
            remark
          )}
        </HStack>
        {children}
      </View>
    );
  },
);
